
/**
 * Checks if the current browser environment is running on an iOS or iPadOS device.
 * * Uses a combination of:
 * 1. User Agent string testing (for iPhone/iPod/older iPadOS).
 * 2. Platform + Touch point check (for modern iPadOS 13+ which spoofs a Mac).
 *
 * @returns {boolean} True if the device is identified as iOS or iPadOS.
 */
export const isIOSDevice = () => {
    const ua = navigator.userAgent;
    // Check 1: Standard iOS User Agents (iPhone, iPod, older iPad)
    const isStandardIOS = /iPad|iPhone|iPod/.test(ua);

    // Check 2: Modern iPadOS 13+ detection (which identifies as 'MacIntel' platform
    // but has multiple touch points)
    const isModerniPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

    // If either check is true, it is an iOS/iPadOS device.
    return isStandardIOS || isModerniPadOS;
};

/**
 * Detects iOS version and returns a structured object.
 * * @returns {object|null} An object like { version: '18.3.0', base: 18 } 
 * or null if not an iOS device.
 */
export const getiOSVersionObject = () => {
    const ua = navigator.userAgent;

    // Check if it's an iOS device (iPhone, iPod) or an iPad running modern iPadOS
    const isIOS =
        /iPad|iPhone|iPod/.test(ua) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if (isIOS) {
        // Regex to match "OS X_Y_Z" pattern
        const versionMatch = ua.match(/OS (\d+)_(\d+)_?(\d+)?/);

        if (versionMatch) {
            const major = parseInt(versionMatch[1], 10);
            const minor = parseInt(versionMatch[2], 10);
            const patch = parseInt(versionMatch[3] || 0, 10);

            return {
                version: `${major}.${minor}.${patch}`,
                base: major
            };
        }
    }

    return null;
};

export default getiOSVersionObject;
